import React from 'react';
import { translate } from 'react-i18next';
import { FormHelperText } from '@material-ui/core';
import { Info as InfoIcon } from '@material-ui/icons';
import AccordionSetup from '../AccordionSetup';
import ToggleNumericSetting from '../ToggleNumericSetting';
import LightTooltip from '../../../../common/components/UI/LightTooltip';
import './WorkplanArchiveSettings.scss';

/**
 * @param {{
 *  isLoading: boolean;
 *  step: number;
 *  t: *;
 *  formData: *;
 *  errors: *;
 *  onChange: (name: string, value: any) => void;
 * }} param0
 */
const WorkplanArchiveSettings = ({ isLoading, step, t, formData, errors, onChange }) => {
    const isEnabledAutoArchive = formData.isEnabledAutoArchiveStoppedWorkplans;

    const handleToggleChange = (checked) => {
        onChange('isEnabledAutoArchiveStoppedWorkplans', checked);
        if (!checked) {
            onChange('autoArchiveStoppedWorkplansDelay', 0);
        }
    };

    const handleNumberChange = (value) => {
        onChange('autoArchiveStoppedWorkplansDelay', value);
    };

    return (
        <AccordionSetup
            stepIndex={step.toString()}
            headerTitle={t('globalSetup.workplanArchive.title')}
            summary=""
            t={t}
        >
            <div className="workplan-archive-step">
                <div className="setting-with-info">
                    <ToggleNumericSetting
                        toggleName="isEnabledAutoArchiveStoppedWorkplans"
                        inputName="autoArchiveStoppedWorkplansDelay"
                        toggleValue={formData.isEnabledAutoArchiveStoppedWorkplans}
                        inputValue={formData.autoArchiveStoppedWorkplansDelay}
                        isDisabled={isLoading}
                        label={t('globalSetup.workplanArchive.setAutoArchiveOnStoppedWorkplans')}
                        unitLabel={t('common:days')}
                        isInputDisabled={!isEnabledAutoArchive}
                        onToggleChange={handleToggleChange}
                        onNumberChange={handleNumberChange}
                        errors={errors}
                        t={t}
                    />
                    <LightTooltip
                        title={t('globalSetup.workplanArchive.autoArchiveInfo')}
                        arrow
                        placement="right"
                    >
                        <span className="info-icon">
                            <InfoIcon fontSize="small" />
                        </span>
                    </LightTooltip>
                </div>
                <FormHelperText className="info">{t('globalSetup.workplanArchive.autoArchiveInfoZero')}</FormHelperText>
            </div>
        </AccordionSetup>
    );
};

export default translate(['workplanManager', 'common'])(WorkplanArchiveSettings);

